import { render, staticRenderFns } from "./setout.vue?vue&type=template&id=3d9c7e8f&"
import script from "./setout.vue?vue&type=script&lang=js&"
export * from "./setout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports